import { each, find, has } from 'lodash';
import { COMBOS, VERSION } from '../constant';
import { ActivityTypeEnum, AppTypeEnum, BalanceDiscountRuleEnum, DiscountTypeEnum, EatTypeEnum, InteractiveScenes, OffTypeEnum, ProductRelationEnum, ProductTypeEnum, UsePromoCodeStatusEnum, } from '../enum';
import dayjs from '../lib/dayjs';
import { findActivityProduct, toFixed } from '../lib/utils';
import calculateFee from './calCulateFee';
import getEnableActivityByType from './getEnableActivityByType';
/**
 * 菜单或者订单数据计算
 * @param self this
 * @param products 餐品数据
 * @param opt
 */
export default function calProduct(self, products, opt) {
    const notCalResult = { itemMap: {}, usePromoCodeStatus: '', canUseMmg: (self === null || self === void 0 ? void 0 : self.canUseMmg) || false };
    if (!(self === null || self === void 0 ? void 0 : self.canUseMmg)) {
        if (!(opt === null || opt === void 0 ? void 0 : opt.isOrder) && self.inited && self.concessionListeners) {
            if (self.eatType === EatTypeEnum.Mall) {
                self.concessionListeners[InteractiveScenes.MALL_MENU_LIST] &&
                    self.concessionListeners[InteractiveScenes.MALL_MENU_LIST](null, notCalResult);
            }
            else {
                self.concessionListeners[InteractiveScenes.MENU_LIST] &&
                    self.concessionListeners[InteractiveScenes.MENU_LIST](null, notCalResult);
            }
        }
        return notCalResult;
    }
    const itemMap = {}; // 优惠数据
    let usePromoCodeStatus = (opt === null || opt === void 0 ? void 0 : opt.usePromoCodeStatus) || UsePromoCodeStatusEnum.Unused;
    if ((opt === null || opt === void 0 ? void 0 : opt.promoCodes) && opt.promoCodes.length > 0) {
        usePromoCodeStatus = UsePromoCodeStatusEnum.Ineffective;
    }
    const usePromoCodeStatusMap = {};
    const singleTyps = [ActivityTypeEnum.SingleItemDiscount, ActivityTypeEnum.SpecialOffer];
    if (self.eatType === EatTypeEnum.Mall) {
        singleTyps.push(ActivityTypeEnum.GroupBuy);
    }
    const singleItemActivitys = getEnableActivityByType({
        channel: self.channel,
        activities: self.activities,
        config: self.config,
        optMemberCard: self.optMemberCard || null,
        availableCards: self.availableCards,
        eatType: self.eatType,
        addTimeout: self.addTimeout,
    }, singleTyps, opt); // 单品活动
    let productPlan = {}; // 手动单品折扣
    if ((opt === null || opt === void 0 ? void 0 : opt.isOrder) && opt.itemPlan) {
        productPlan = opt.itemPlan;
    }
    const alearedJoinFullItemPks = (opt === null || opt === void 0 ? void 0 : opt.alearedJoinFullItemPks) || [];
    const activityPurchaseLimitMap = {};
    if (self.timeZone) {
        dayjs.tz.setDefault(self.timeZone);
    }
    each(products, (product) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        let productPrice = product.price;
        product.productAndModifierPrice = toFixed(product.price + ((_a = product.modifierPrice) !== null && _a !== void 0 ? _a : 0));
        let id = product.pk || product.productNo + '_' + product.scaleNo;
        if (product.type === ProductTypeEnum.Modifier && !(opt === null || opt === void 0 ? void 0 : opt.isOrder)) {
            id = product.productNo + '_' + product.modifierGroupNo + '_' + product.modifierNo;
        }
        itemMap[id] = Object.assign(Object.assign({}, product), { off: product.off || 0 });
        const productCnt = product.cnt || 1;
        if (productPlan[id] && product.type !== ProductTypeEnum.Modifier) {
            if (productPlan[id].isIncludeModifier) {
                productPrice = product.productAndModifierPrice;
            }
            let off = 0; // 优惠金额
            if (productPlan[id].discountType === DiscountTypeEnum.DiscountFee) {
                off = productPlan[id].discountValue * productCnt;
                if (off < 0) {
                    off = 0;
                }
                if (off > productPrice * productCnt) {
                    off = productPrice * productCnt;
                }
            }
            else if (productPlan[id].discountType === DiscountTypeEnum.DiscountRate) {
                off = toFixed(productPrice * (1 - productPlan[id].discountValue)) * productCnt;
            }
            itemMap[id].off = off;
            itemMap[id].offTip = productPlan[id].discountReason;
            itemMap[id].offId = productPlan[id].tagId;
            itemMap[id].offType = OffTypeEnum.Plan;
            itemMap[id].isIncludeModifier = productPlan[id].isIncludeModifier || false;
            itemMap[id].tagId = productPlan[id].tagId;
        }
        else {
            if (has(product, 'isOverlySingleItemDiscount') && !product.isOverlySingleItemDiscount) {
                return;
            }
            if (has(product, 'isFullItemNFree') && product.isFullItemNFree) {
                return;
            }
            if (alearedJoinFullItemPks.includes(product.pk || '') && product.type !== ProductTypeEnum.Modifier) {
                return;
            }
            each(singleItemActivitys, (activity) => {
                var _a, _b, _c, _d;
                // 活动关联会员卡,卡的余额不足的时候,菜单活动价格不返回
                if (!activity.isAllMember &&
                    !(opt === null || opt === void 0 ? void 0 : opt.isOrder) &&
                    ((((_b = (_a = self.optMemberCard) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay &&
                        product.price > self.optMemberCard.balance) ||
                        (((_d = (_c = self.optMemberCard) === null || _c === void 0 ? void 0 : _c.extra) === null || _d === void 0 ? void 0 : _d.balanceDiscountRule) === BalanceDiscountRuleEnum.HasBalance &&
                            self.optMemberCard.balance <= 0))) {
                    return true;
                }
                if (((product.type === ProductTypeEnum.Product ||
                    product.type === ProductTypeEnum.MallProduct ||
                    product.type === ProductTypeEnum.Modifier) &&
                    activity.productRelation === ProductRelationEnum.All) ||
                    (COMBOS.includes(product.type) && activity.productComboRelation === ProductRelationEnum.All)) {
                    // 优惠计算
                    usePromoCodeStatus = calculateFee({
                        activity,
                        product,
                        itemMap,
                        usePromoCodeStatus,
                        usePromoCodeStatusMap,
                        isUseGroupBuy: (opt === null || opt === void 0 ? void 0 : opt.isUseGroupBuy) || false,
                        activityPurchaseLimitMap,
                        isOrder: (opt === null || opt === void 0 ? void 0 : opt.isOrder) || false,
                    });
                }
                else if (((product.type === ProductTypeEnum.Product ||
                    product.type === ProductTypeEnum.MallProduct ||
                    product.type === ProductTypeEnum.Modifier) &&
                    (activity.productRelation === ProductRelationEnum.Included ||
                        activity.productRelation === ProductRelationEnum.Excluded)) ||
                    (COMBOS.includes(product.type) &&
                        (activity.productComboRelation === ProductRelationEnum.Included ||
                            activity.productComboRelation === ProductRelationEnum.Excluded))) {
                    const findProduct = findActivityProduct(activity.productMap, product);
                    if (findProduct &&
                        (((product.type === ProductTypeEnum.Product ||
                            product.type === ProductTypeEnum.MallProduct ||
                            product.type === ProductTypeEnum.Modifier) &&
                            activity.productRelation === ProductRelationEnum.Included) ||
                            (COMBOS.includes(product.type) && activity.productComboRelation === ProductRelationEnum.Included))) {
                        // 优惠计算
                        usePromoCodeStatus = calculateFee({
                            activity,
                            product,
                            itemMap,
                            usePromoCodeStatus,
                            usePromoCodeStatusMap,
                            isUseGroupBuy: (opt === null || opt === void 0 ? void 0 : opt.isUseGroupBuy) || false,
                            activityPurchaseLimitMap,
                            isOrder: (opt === null || opt === void 0 ? void 0 : opt.isOrder) || false,
                        });
                    }
                    else if (!findProduct &&
                        ((product.type === ProductTypeEnum.Product && activity.productRelation === ProductRelationEnum.Excluded) ||
                            (COMBOS.includes(product.type) && activity.productComboRelation === ProductRelationEnum.Excluded))) {
                        // 优惠计算
                        usePromoCodeStatus = calculateFee({
                            activity,
                            product,
                            itemMap,
                            usePromoCodeStatus,
                            usePromoCodeStatusMap,
                            isUseGroupBuy: (opt === null || opt === void 0 ? void 0 : opt.isUseGroupBuy) || false,
                            activityPurchaseLimitMap,
                            isOrder: (opt === null || opt === void 0 ? void 0 : opt.isOrder) || false,
                        });
                    }
                }
            });
            const cardDiscountType = ((_b = self.optMemberCard) === null || _b === void 0 ? void 0 : _b.discountType) || '';
            // 有会员卡且会员价的打折方式不是会员价
            if (self.optMemberCard &&
                cardDiscountType &&
                cardDiscountType !== DiscountTypeEnum.MemberPrice &&
                ((_d = (_c = itemMap[id]) === null || _c === void 0 ? void 0 : _c.activity) === null || _d === void 0 ? void 0 : _d.type) !== ActivityTypeEnum.GroupBuy &&
                ((COMBOS.includes(product.type) && self.optMemberCard.isIncludeCombo) || !COMBOS.includes(product.type))) {
                const cardProductRelation = self.optMemberCard.productRelation;
                let findCardProduct;
                if (self.optMemberCard.productMap) {
                    findCardProduct = findActivityProduct(self.optMemberCard.productMap, product);
                }
                else {
                    findCardProduct = find(self.optMemberCard.products, (mp) => (mp.categoryNo === product.categoryNo && !mp.productNo) || // 分类下面全部餐品
                        (mp.categoryNo === product.categoryNo && mp.productNo === product.productNo));
                }
                if (cardProductRelation === ProductRelationEnum.All ||
                    (cardProductRelation === ProductRelationEnum.Excluded && !findCardProduct) ||
                    (cardProductRelation === ProductRelationEnum.Included && findCardProduct)) {
                    let memberProductPrice = product.price;
                    if (self.optMemberCard.isIncludeModifier) {
                        memberProductPrice = product.productAndModifierPrice;
                    }
                    else {
                        if (product.type === ProductTypeEnum.Modifier) {
                            memberProductPrice = 0;
                        }
                    }
                    const cardDiscountValue = ((_e = self.optMemberCard) === null || _e === void 0 ? void 0 : _e.discountValue) || 0;
                    let memberOff = toFixed(memberProductPrice * (1 - cardDiscountValue) * (product.cnt || 1));
                    if (!(opt === null || opt === void 0 ? void 0 : opt.isOrder) &&
                        ((((_g = (_f = self.optMemberCard) === null || _f === void 0 ? void 0 : _f.extra) === null || _g === void 0 ? void 0 : _g.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay &&
                            product.price > self.optMemberCard.balance) ||
                            (((_j = (_h = self.optMemberCard) === null || _h === void 0 ? void 0 : _h.extra) === null || _j === void 0 ? void 0 : _j.balanceDiscountRule) === BalanceDiscountRuleEnum.HasBalance &&
                                self.optMemberCard.balance <= 0))) {
                        memberOff = 0;
                    }
                    if (memberOff > itemMap[id].off) {
                        itemMap[id].off = memberOff;
                        itemMap[id].offTip = self.optMemberCard.cardName;
                        itemMap[id].offId = self.optMemberCard.cardId;
                        itemMap[id].offType = OffTypeEnum.MemberCard;
                        itemMap[id].isIncludeModifier = self.optMemberCard.isIncludeModifier || false;
                        usePromoCodeStatusMap[id] = UsePromoCodeStatusEnum.Ineffective;
                    }
                }
            }
            let memberPriceMap = self.memberPriceMap;
            let memberPricePlanName = self.memberPricePlanName;
            let memberPricePlanId = self.memberPricePlanId;
            let onlyInSideMemberPrice = self.onlyInSideMemberPrice;
            if (self.eatType === EatTypeEnum.Mall) {
                memberPriceMap = self.mallMemberPriceMap;
                memberPricePlanName = self.mallMemberPricePlanName;
                memberPricePlanId = self.mallMemberPricePlanId;
                onlyInSideMemberPrice = self.mallOnlyInSideMemberPrice;
            }
            if (memberPriceMap && product.type !== ProductTypeEnum.Modifier) {
                const memberPrice = memberPriceMap[product.productNo] || memberPriceMap[product.productNo + '_' + product.scaleNo];
                if (memberPrice) {
                    // 什么时候都会有会员价
                    itemMap[id].memberPrice = memberPrice.price;
                    // 在菜单页，且现在计算的卡是外部卡，且只有内部卡有会员价的时候，会员价在菜单展示0
                    // 没有卡的时候，会员价也是内部卡的时候也不展示
                    if (!(opt === null || opt === void 0 ? void 0 : opt.isOrder) &&
                        (((_k = self.optMemberCard) === null || _k === void 0 ? void 0 : _k.publishType) === 'outside' || !self.optMemberCard) &&
                        onlyInSideMemberPrice) {
                        itemMap[id].memberPrice = 0;
                    }
                    // 会员卡的打折方式是会员价的时候
                    if (cardDiscountType === DiscountTypeEnum.MemberPrice) {
                        const memberPriceOff = toFixed((product.price - memberPrice.price - (product.addPrice || 0)) * (product.cnt || 1));
                        // 不是订单的时候
                        if (memberPriceOff > itemMap[id].off) {
                            itemMap[id].off = memberPriceOff;
                            itemMap[id].offTip = memberPricePlanName;
                            itemMap[id].offId = memberPricePlanId;
                            itemMap[id].offType = OffTypeEnum.MemberPrice;
                            usePromoCodeStatusMap[id] = UsePromoCodeStatusEnum.Ineffective;
                            if (!(opt === null || opt === void 0 ? void 0 : opt.isOrder) &&
                                ((((_m = (_l = self.optMemberCard) === null || _l === void 0 ? void 0 : _l.extra) === null || _m === void 0 ? void 0 : _m.balanceDiscountRule) === BalanceDiscountRuleEnum.OnlyBalancePay &&
                                    product.price > self.optMemberCard.balance) ||
                                    (((_p = (_o = self.optMemberCard) === null || _o === void 0 ? void 0 : _o.extra) === null || _p === void 0 ? void 0 : _p.balanceDiscountRule) === BalanceDiscountRuleEnum.HasBalance &&
                                        self.optMemberCard.balance <= 0))) {
                                itemMap[id].off = 0;
                                itemMap[id].offType = '';
                            }
                        }
                    }
                }
            }
        }
        if (self.productPlan && !(opt === null || opt === void 0 ? void 0 : opt.isOrder) && product.type !== ProductTypeEnum.Modifier) {
            itemMap[id].plan = {
                planId: self.productPlan.planId,
                discountReasons: self.productPlan.discountReasons,
                tags: [],
                roles: self.productPlan.roles,
            };
            each(self.productPlan.tags, (tag) => {
                var _a, _b;
                const findProduct = findActivityProduct(tag.productMap, product);
                if (tag.productRelation === ProductRelationEnum.All ||
                    (findProduct && tag.productRelation === ProductRelationEnum.Included) ||
                    (!findProduct && tag.productRelation === ProductRelationEnum.Excluded)) {
                    (_b = (_a = itemMap[id].plan) === null || _a === void 0 ? void 0 : _a.tags) === null || _b === void 0 ? void 0 : _b.push({
                        planTagId: tag.planTagId,
                        tagName: tag.tagName,
                        discountType: tag.discountType,
                        discountValue: tag.discountValue,
                        isIncludeModifier: tag.isIncludeModifier,
                    });
                }
            });
        }
        if (opt === null || opt === void 0 ? void 0 : opt.isOrder) {
            if (itemMap[id].off <= 0) {
                delete itemMap[id];
            }
        }
        else {
            if (itemMap[id].off <= 0 && !itemMap[id].plan && !itemMap[id].memberPrice && !itemMap[id].groupBuyPrice) {
                delete itemMap[id];
            }
        }
    });
    if (usePromoCodeStatus === UsePromoCodeStatusEnum.Effective) {
        if (!find(usePromoCodeStatusMap, (status) => status === UsePromoCodeStatusEnum.Effective)) {
            usePromoCodeStatus = UsePromoCodeStatusEnum.Ineffective;
        }
    }
    const result = {
        itemMap,
        orderPlan: self.orderPlan,
        usePromoCodeStatus,
        version: VERSION,
    };
    if (self.appType === AppTypeEnum.Mobile && !(opt === null || opt === void 0 ? void 0 : opt.isOrder)) {
        result.activities = getEnableActivityByType(self, [...Object.values(ActivityTypeEnum)], opt);
    }
    if (!(opt === null || opt === void 0 ? void 0 : opt.isOrder) && self.inited && self.concessionListeners) {
        if (self.eatType === EatTypeEnum.Mall) {
            self.concessionListeners[InteractiveScenes.MALL_MENU_LIST] &&
                self.concessionListeners[InteractiveScenes.MALL_MENU_LIST](null, result);
        }
        else {
            self.concessionListeners[InteractiveScenes.MENU_LIST] &&
                self.concessionListeners[InteractiveScenes.MENU_LIST](null, result);
        }
    }
    return result;
}
//# sourceMappingURL=calProduct.js.map